// product page tab block

document.querySelectorAll(".tab-titles a").forEach((link, index) => {
  link.addEventListener("click", function (event) {
    event.preventDefault();

    // Hide all tab contents
    document
      .querySelectorAll(".tab-content")
      .forEach((content) => content.classList.remove("active"));

    // Remove active class from all links
    document
      .querySelectorAll(".tab-titles a")
      .forEach((link) => link.classList.remove("active"));

    // Show the clicked tab content
    document.querySelector(this.getAttribute("href")).classList.add("active");

    // Set active class on clicked tab title
    this.classList.add("active");

    // Move the indicator below the active tab
    moveIndicator(this);
  });
});

// Initial active tab and indicator
const firstTab = document.querySelector(".tab-titles a");
firstTab.classList.add("active");
document.querySelector(".tab-content").classList.add("active");
moveIndicator(firstTab);

// Function to move the indicator
function moveIndicator(activeTab) {
  const indicator = document.querySelector(".tab-indicator");
  const tabRect = activeTab.getBoundingClientRect();
  const titlesRect =
    activeTab.parentElement.parentElement.getBoundingClientRect();

  indicator.style.width = `${tabRect.width}px`;
  indicator.style.left = `${tabRect.left - titlesRect.left}px`;
}

$(document).ready(function () {
  const $descriptionWrapper = $("#tab-pro_desc .product-description-wrapper");
  const $toggleButton = $("#toggle-description");
  const initialHeight = 100; // Set the initial height to match the portion you want to display.

  // Initial setup: Restrict the height and prepare for toggle
  $descriptionWrapper
    .css("max-height", initialHeight + "px")
    .css("overflow", "hidden");

  // Toggle functionality using slideToggle
  $toggleButton.on("click", function () {
    const isExpanded = $descriptionWrapper.data("expanded") === true;

    if (isExpanded) {
      $descriptionWrapper.animate({ maxHeight: initialHeight + "px" }, 300); // Collapse
      $descriptionWrapper.data("expanded", false);
      $toggleButton.text("See More");
    } else {
      $descriptionWrapper.animate(
        { maxHeight: $descriptionWrapper[0].scrollHeight + "px" },
        300
      ); // Expand
      $descriptionWrapper.data("expanded", true);
      $toggleButton.text("See Less");
    }
  });
});

  
  // const $mobileRead = $("#mobile_read"); // Target the content div
  // const $toggleButton = $("#toggle-content"); // Target the button
  // const fullText = $mobileRead.html().trim(); // Get the full content
  // const wordLimit = 80; // Word limit for truncation (80 words)
  // const words = fullText.split(/\s+/); // Split content into words, handling multiple spaces

  // // Only proceed if the text exceeds the word limit
  // if (words.length > wordLimit) {
  //   const truncatedText = words.slice(0, wordLimit).join(" ") + "..."; // Truncated version with ellipsis
  //   $mobileRead.data("full-text", fullText); // Store the full content in a data attribute
  //   $mobileRead.data("truncated-text", truncatedText); // Store the truncated content
  //   $mobileRead.html(truncatedText); // Display the truncated version
  //   $mobileRead.data("expanded", false); // Set initial state as collapsed

  //   // Toggle between truncated and full content when the button is clicked
  //   $toggleButton.on("click", function () {
  //     const isExpanded = $mobileRead.data("expanded");

  //     if (isExpanded) {
  //       $mobileRead.html($mobileRead.data("truncated-text")); // Collapse to truncated version
  //       $mobileRead.data("expanded", false);
  //       $toggleButton.text("Read More");
  //     } else {
  //       $mobileRead.html($mobileRead.data("full-text")); // Expand to full content
  //       $mobileRead.data("expanded", true);
  //       $toggleButton.text("Read Less");
  //     }
  //   });
  // } else {
  //   $toggleButton.hide(); // Hide the button if the content is already within the word limit
  // }

